module.exports = __webpack_public_path__ + "static/media/infoDialogC_background.74e44b98.png";


//////////////////
// WEBPACK FOOTER
// ./src/infoDialogC/static/infoDialogC_background.png
// module id = 413
// module chunks = 0